import { render, staticRenderFns } from "./HomePageTemplate.vue?vue&type=template&id=420c46ae&scoped=true"
import script from "./HomePageTemplate.vue?vue&type=script&lang=js"
export * from "./HomePageTemplate.vue?vue&type=script&lang=js"
import style0 from "./HomePageTemplate.vue?vue&type=style&index=0&id=420c46ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c46ae",
  null
  
)

export default component.exports